export const HostEnvironment = {
    // @ts-ignore
    staticHosts: ['https://cdn.vkcloud-static.ru', 'https://static-vktechdevm.s3.prodcloud.vk.team'] || [], // реплейсится на список хостов при старте докер образа
};
